var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotionDingDong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4152_20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#A6A6A6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.359 12.6471H8.87179C8.11015 12.6471 7.3797 12.9445 6.84113 13.4741C6.30256 14.0036 6 14.7217 6 15.4706V21.1176C6 21.8665 6.30256 22.5847 6.84113 23.1142C7.3797 23.6437 8.11015 23.9412 8.87179 23.9412H10.3077V29.5882C10.3077 29.9627 10.459 30.3217 10.7283 30.5865C10.9975 30.8513 11.3628 31 11.7436 31H14.6154C14.9962 31 15.3614 30.8513 15.6307 30.5865C15.9 30.3217 16.0513 29.9627 16.0513 29.5882V23.9412H20.359L27.5385 29.5882V7L20.359 12.6471ZM24.6667 23.3765L21.7949 21.1176H8.87179V15.4706H21.7949L24.6667 13.2118V23.3765ZM34 18.2941C34 20.7082 32.6215 22.8965 30.4103 23.9412V12.6471C32.6072 13.7059 34 15.8941 34 18.2941Z",
    fill: "#A6A6A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4152_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionDingDong);
export default __webpack_public_path__ + "static/media/Promotion_DingDong.aa3465b5ecf8d4c6d23dee0f59f956f5.svg";
export { ForwardRef as ReactComponent };